module.exports = __webpack_public_path__ + "img/4.23a6ed1f.png";